import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

const empty = { current: "", next: "", confirm: "" };

export const ChangePasswordCard = ({ hasPassword = true }) => {
  const [f, setF] = useState(empty);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 6) { setError("New password must be at least 6 characters"); return; }
    if (f.next !== f.confirm) { setError("New passwords don't match"); return; }
    setSaving(true); setError("");
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password updated");
      setF(empty);
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Card className="p-6 rounded-2xl" data-testid="change-password-card">
      <h3 className="font-display text-lg font-bold flex items-center gap-2"><KeyRound className="w-5 h-5 text-ys-sky" />{hasPassword ? "Change password" : "Set a password"}</h3>
      <p className="text-sm text-slate-500 mb-4">{hasPassword ? "Enter your current password, then choose a new one." : "You signed in with Google — add a password to also sign in with your email."}</p>
      <form onSubmit={submit} className="grid sm:grid-cols-3 gap-3">
        {hasPassword && (
          <div><Label>Current password</Label><Input type="password" value={f.current} onChange={set("current")} required data-testid="cp-current" className="mt-1.5 rounded-xl h-11" /></div>
        )}
        <div><Label>New password</Label><Input type="password" value={f.next} onChange={set("next")} required data-testid="cp-new" className="mt-1.5 rounded-xl h-11" placeholder="At least 6 characters" /></div>
        <div><Label>Confirm new password</Label><Input type="password" value={f.confirm} onChange={set("confirm")} required data-testid="cp-confirm" className="mt-1.5 rounded-xl h-11" /></div>
        {error && <p className="sm:col-span-3 text-sm text-red-600" data-testid="cp-error">{error}</p>}
        <div className="sm:col-span-3"><Button type="submit" disabled={saving} data-testid="cp-submit" className="rounded-full bg-ys-sky hover:bg-sky-700">{saving ? "Saving..." : "Update password"}</Button></div>
      </form>
    </Card>
  );
};
